module.exports = __webpack_public_path__ + "img/v2-redesign-company-profile.be4e988f.png";